import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { BAD_BARS_BG, BAD_BARS_HOVER_BG } from "@/shared/colors";
import Paper from "@mui/material/Paper";
import { SxProps, Theme } from "@mui/material/styles";
import { GridApi, RowClassParams, RowClickedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useBundlesTableData } from "../hooks/useBundlesTableData";
import { LengthBundleRow } from "../models/LengthBundleRow";

const BAD_BARS_ROW_CLASS = "bad-bars-row";

const getBadBarsRowClass = (
	params: RowClassParams<LengthBundleRow>,
): string | undefined => {
	if (params.data && params.data.BadBars > 0) {
		return BAD_BARS_ROW_CLASS;
	}
	return undefined;
};

const badBarsRowStyles: SxProps<Theme> = {
	[`& .${BAD_BARS_ROW_CLASS}`]: {
		backgroundColor: BAD_BARS_BG,
	},
	[`& .${BAD_BARS_ROW_CLASS}:hover`]: {
		backgroundColor: `${BAD_BARS_HOVER_BG} !important`,
	},
	[`& .${BAD_BARS_ROW_CLASS}.ag-row-selected`]: {
		backgroundColor: BAD_BARS_HOVER_BG,
	},
};

type Props = {
	isLoading: boolean;
	rows: LengthBundleRow[];
	setGridApi: (api: GridApi) => void;
	onRowClicked: (bundleId: number) => void;
};

export const LengthBundlesTable = ({
	isLoading,
	rows,
	setGridApi,
	onRowClicked,
}: Props) => {
	const { columnDefs } = useBundlesTableData();

	const handleRowClicked = (event: RowClickedEvent<LengthBundleRow>) => {
		if (event.data?.BundleId != null) {
			onRowClicked(event.data.BundleId);
		}
	};

	return (
		<Paper
			elevation={2}
			sx={{ height: "100%", overflow: "hidden", ...badBarsRowStyles }}
		>
			<AgGridReact<LengthBundleRow>
				loading={isLoading}
				rowData={rows}
				columnDefs={columnDefs}
				animateRows
				onGridReady={(params) => setGridApi(params.api)}
				onRowClicked={handleRowClicked}
				loadingOverlayComponent={CenteredLazyLoading}
				getRowId={(params) => `${params.data.BundleId}`}
				getRowClass={getBadBarsRowClass}
				gridOptions={{
					rowSelection: {
						mode: "singleRow",
						checkboxes: false,
						enableClickSelection: true,
					},
				}}
				suppressContextMenu
			/>
		</Paper>
	);
};
